<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h3 class="heading">Processing Fee Payment</h3>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box">
                <div class="text-center">
                    <p class="content">
                        To proceed with your application, please complete the payment of the<br />
                        <b>Processing Fee</b> as shown below.
                    </p>

                    <div class="pricings">
                        <table>
                            <tr>
                                <td>
                                    <p>
                                        <i class="fas fa-money-check-alt"></i> Total Payable:
                                    </p>
                                </td>
                                <th>
                                    ₹ {{ processingFee }}
                                </th>
                            </tr>

                            <tr>
                                <td>
                                    <p>
                                        ✅ Processing Fee <br />
                                        <span>(one-time charge)</span>
                                    </p>
                                </td>
                                <th>₹ {{ processingFee }}</th>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="row justify-content-center text-center buttonDiv mb-3">
                    <div class="col-12">
                        <button class="btn btn-warning confitm_btn" (click)="initiatePayment()">
                            Pay Processing Fee
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>